import React from 'react'
import {
  AspectRatioCornerResizeHandles,
  AspectRatioBottomLeftResizeHandle,
  AspectRatioBottomRightResizeHandle,
  AspectRatioTopLeftResizeHandle,
  AspectRatioTopRightResizeHandle,
} from './AspectRatioResizeHandle'
import { FreeformCornerResizeHandles } from './FreeformCornerResizeHandle'
import { HorizontalEdgeResizeHandles } from './HorizontalEdgeResizeHandles'

export default function ResizeHandles({
  resizeCorners,
  resizeBottomLeft,
  resizeBottomRight = true,
  resizeTopLeft,
  resizeTopRight,
  resizeFreeform,
  resizeHorizontalOnly,
  getBounds,
  maxSize,
  minSize,
  testIdPrefix,
  rotation,
  value,
  defaultSize,
}) {
  return (
    <>
      {resizeHorizontalOnly && (
        <HorizontalEdgeResizeHandles
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-horizontal-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
        />
      )}
      {resizeFreeform && !resizeHorizontalOnly && (
        <FreeformCornerResizeHandles
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-freeform-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
        />
      )}
      {resizeCorners && !resizeFreeform && !resizeHorizontalOnly && (
        <AspectRatioCornerResizeHandles
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-aspect-ratio-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
          value={value}
          defaultSize={defaultSize}
        />
      )}
      {resizeBottomLeft && !resizeCorners && !resizeFreeform && !resizeHorizontalOnly && (
        <AspectRatioBottomLeftResizeHandle
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-aspect-ratio-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
          value={value}
          defaultSize={defaultSize}
        />
      )}
      {resizeBottomRight && !resizeCorners && !resizeFreeform && !resizeHorizontalOnly && (
        <AspectRatioBottomRightResizeHandle
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-aspect-ratio-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
          value={value}
        />
      )}
      {resizeTopLeft && !resizeCorners && !resizeFreeform && !resizeHorizontalOnly && (
        <AspectRatioTopLeftResizeHandle
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-aspect-ratio-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
          value={value}
          defaultSize={defaultSize}
        />
      )}
      {resizeTopRight && !resizeCorners && !resizeFreeform && !resizeHorizontalOnly && (
        <AspectRatioTopRightResizeHandle
          testIdPrefix={testIdPrefix ? `${testIdPrefix}-aspect-ratio-resize-handle` : undefined}
          getBounds={getBounds}
          maxSize={maxSize}
          minSize={minSize}
          rotation={rotation}
          value={value}
          defaultSize={defaultSize}
        />
      )}
    </>
  )
}
